import { ChangeEvent, FC, MouseEvent, useCallback, useMemo } from 'react';
import { UserGroupEnum } from 'videoservice-openapi-react';
import { useUpdateBroadcast } from 'features/broadcast/update-broadcast';
import { useAuthContext } from 'shared/lib/user';
import { Toggle } from 'shared/ui';
import { IStatusCellProps } from './status-cell.types';

export const StatusCell: FC<IStatusCellProps> = ({ item }) => {
  const { user } = useAuthContext();

  const { updateBroadcast, updateBroadcastMutation } = useUpdateBroadcast(
    item.id,
    user,
  );

  const isEnabled = useMemo(() => {
    if (user.group === UserGroupEnum.CUSTOMER) {
      return item.customerSettings?.enabled ?? item.enabled;
    } else {
      return item.enabled;
    }
  }, [item.customerSettings?.enabled, item.enabled, user.group]);

  const toggleChangeHandler = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      updateBroadcast({ enabled: e.target.checked });
    },
    [updateBroadcast],
  );

  const toggleClickHandler = useCallback((e: MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <span onClick={toggleClickHandler}>
      <Toggle
        checked={isEnabled}
        disabled={updateBroadcastMutation.isPending}
        onChange={toggleChangeHandler}
      />
    </span>
  );
};
